import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { fetchWithTimeout } from "../../App";
import "../../index.css";
import "../../App.css";

const API_URL = process.env.REACT_APP_API_URL;

function AdminLayout() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await fetchWithTimeout(`${API_URL}/api/admin/logout`, {
        method: "POST",
        credentials: "include",
      }, 5000);
    } catch (_) {}
    navigate("/admin/login");
  };

  const navItems = [
    { to: "/admin", label: "Dashboard", emoji: "📊", end: true },
    { to: "/admin/orders", label: "Orders", emoji: "📋" },
    { to: "/admin/sessions", label: "Sessions", emoji: "📅" },
    { to: "/admin/recipes", label: "Recipes", emoji: "🍳" },
    { to: "/admin/reports", label: "Reports", emoji: "📈" },
    { to: "/admin/settings", label: "Settings", emoji: "⚙️" },
  ];

  return (
    <div className="mama-page">
      {/* Desktop Sidebar */}
      <aside className="mama-sidebar">
        <div className="mama-sidebar-brand">
          <div className="mama-logo-wrap">
            <img
              src={`${process.env.PUBLIC_URL}/logo.png`}
              alt="Mama Bacamel"
              className="mama-logo-img"
              onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "block"; }}
            />
            <span className="mama-logo-fallback" style={{ display: "none" }}>🍝</span>
          </div>
          <p className="mama-tagline">admin panel 🔧</p>
        </div>

        <nav className="mama-nav-links">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `mama-nav-link${isActive ? " active" : ""}`}
            >
              <span className="nav-emoji">{item.emoji}</span> {item.label}
            </NavLink>
          ))}
        </nav>

        <button onClick={handleLogout} className="admin-logout-btn">
          🚪 Log Out
        </button>
      </aside>

      {/* Mobile Bottom Nav */}
      <div className="admin-bottom-nav">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `mama-bottom-link${isActive ? " active" : ""}`}
          >
            <span className="bottom-emoji">{item.emoji}</span>
            {item.label}
          </NavLink>
        ))}
      </div>

      {/* Page Content */}
      <div className="mama-main">
        <Outlet />
      </div>
    </div>
  );
}

export default AdminLayout;
